import { jsx as _jsx } from "react/jsx-runtime";
import { List, ListItem } from "@mui/material";
import { useEffect, useRef, useState } from "react";
export function ListHighlight({ options, getKey, renderItem, onSelect, disabled, }) {
    const [listHighlightIndex, setListHighlightIndex] = useState(0);
    const listRef = useRef(null);
    useEffect(() => {
        if (listHighlightIndex >= options.length || listHighlightIndex < 0) {
            setListHighlightIndex(Math.max(0, options.length - 1));
        }
    }, [options, listHighlightIndex]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Unstable dependencies
    useEffect(() => {
        function handleKeyDown(event) {
            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                const nextIndex = Math.max(0, Math.min(options.length - 1, listHighlightIndex + (event.key === "ArrowUp" ? -1 : 1)));
                setListHighlightIndex(nextIndex);
                listRef.current?.children[nextIndex]?.scrollIntoView({
                    block: "nearest",
                    inline: "nearest",
                    behavior: "instant",
                });
            }
            else if (event.key === "Enter") {
                const option = options?.[listHighlightIndex];
                if (option) {
                    onSelect({ option, index: listHighlightIndex });
                }
            }
        }
        if (!disabled) {
            addEventListener("keydown", handleKeyDown);
        }
        return () => removeEventListener("keydown", handleKeyDown);
    }, [options, listHighlightIndex, disabled]);
    return (_jsx(List, { ref: listRef, disablePadding: true, children: options?.map((option, index) => (_jsx(ListItem, { disablePadding: true, onMouseMove: () => setListHighlightIndex(index), sx: listHighlightIndex === index
                ? { bgcolor: ({ palette }) => palette.action.hover }
                : {}, children: renderItem({ option, index }) }, getKey({ option, index })))) }));
}
//# sourceMappingURL=ListHighlight.js.map